import { Box, Typography, Button, Grid, Card, CardContent, CardMedia, Divider, Dialog, DialogTitle, TextField, RadioGroup, FormControlLabel, Radio, DialogActions,useMediaQuery } from '@mui/material';

import React , {useState}from "react";
import { useTheme} from '@mui/material';
import axios from "axios";
import homebanner from "../../assets/image/png/homebanner.jpg"
import mflyingdrone1 from "../../assets/image/png/mflyingdrone1.jpg"
import arrdown from "../../assets/image/png/arrowdown.png"
import arrup from "../../assets/image/png/arrowup.png"
import revenueopp from "../../assets/image/png/revenueopp.jpg"
import ongoing from "../../assets/image/png/Layer41.png"
import layer5 from "../../assets/image/png/Layer5.png"
import submitInterestImage from "../../assets/image/png/Requirenment.png"
import requirement1 from "../../assets/image/png/Requirement1.png"
import requirement2 from "../../assets/image/png/Requirement2.png"
import { toast } from "react-toastify";
import { fireGtagEvent } from "../../utils/gtagEvents";


const FranchisePage = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const [formData, setFormData] = useState({
      name: '',
      email: '',
      phone: '',
      organization: '',
      city: '',
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };
  
  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  
  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    fireGtagEvent("qualify_lead");
    const { name, email, phone, organization, city } = formData;
 
    // Basic validation check
    if (!name || !email || !phone || !organization || !city) {
      toast.error("All fields are required.");
      handleDialogClose();
      return;
    }
 
    try {
      const response = await axios.post(
          process.env.REACT_APP_API_URL + "/addRptoDatas", {
          name,
          phone,
          email,
          organization,
          city
        })
 
      console.log('Form submitted successfully:', response.data);
      toast.success("Form Submitted Successfully!");
      setShowAlert(true);
 
      // Reset form fields
      setFormData({
        name: '',
        email: '',
        phone: '',
        organization: '',
        city: '',
      });

      handleDialogClose();

    } catch (err) {
      toast.error("Error submitting the form.");
      setShowAlert(false);
    }
 };
  return (
    <Box sx={{mt:3}}>
      {/* Hero Section */}
      <Box
  sx={{
    position: "relative",
    backgroundImage: `url(${homebanner})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    minHeight: { xs: "auto", md: 560 },
    px: { xs: 2, sm: 4, md: 6 },
    py: { xs: 6, md: 10 },
    color: "white",
  }}
>
  {/* Overlay */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      background:
        "linear-gradient(to bottom, rgba(0,0,0,0.45), rgba(0,0,0,0.25))",
      zIndex: 0,
    }}
  />

  {/* CONTENT */}
  <Box
    sx={{
      position: "relative",
      zIndex: 1,
      maxWidth: 1200,
      mx: "auto",
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "1.2fr 1fr" },
      gap: { xs: 5, md: 8 },
      alignItems: "center",
    }}
  >
    {/* ================= LEFT CONTENT ================= */}
    <Box>
      <Typography
        sx={{
          fontWeight: 400,
          letterSpacing: 1,
          fontSize: { xs: 12, sm: 14, md: 16 },
        }}
      >
        PARTNER WITH DRONE PLANET
      </Typography>

      <Typography
        sx={{
          mt: 1,
          fontWeight: 600,
          fontSize: { xs: "1.4rem", sm: "1.8rem", md: "2.3rem" },
        }}
      >
        LAUNCH YOUR DGCA-CERTIFIED RPTO FRANCHISE!
      </Typography>

      <Typography
        sx={{
          mt: 2,
          fontSize: { xs: 13, sm: 15, md: 16 },
          maxWidth: 520,
          lineHeight: 1.6,
        }}
      >
        Join the drone revolution by opening a DGCA-approved Remote Pilot
        Training Organization (RPTO) and contribute to building the future of
        drone pilots.
      </Typography>
    </Box>

    {/* ================= RIGHT FORM ================= */}
    <Box
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        borderRadius: 3,
        p: { xs: 2.5, sm: 3.5 },
        boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
      }}
    >
      <Typography
        align="center"
        fontWeight={600}
        fontSize={{ xs: "1.1rem", sm: "1.3rem" }}
        mb={3}
        color="#007bff"
      >
        Register Now
      </Typography>

      <TextField
        fullWidth
        label="Full Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        variant="standard"
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        label="Phone Number"
        name="phone"
        value={formData.phone}
        onChange={(e) =>
          /^\d{0,10}$/.test(e.target.value) && handleChange(e)
        }
        variant="standard"
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        label="Email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        variant="standard"
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        label="Organisation"
        name="organization"
        value={formData.organization}
        onChange={handleChange}
        variant="standard"
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        label="City"
        name="city"
        value={formData.city}
        onChange={handleChange}
        variant="standard"
        sx={{ mb: 3 }}
      />

      <Button
        fullWidth
        variant="contained"
        onClick={handleSubmit}
        sx={{
          backgroundColor: "#007bff",
          borderRadius: 20,
          py: 1.2,
          fontWeight: 600,
          "&:hover": { backgroundColor: "#0256b0" },
        }}
      >
        Submit
      </Button>
    </Box>
  </Box>
</Box>






      {/* Why Partner Section */}
      <Box
  textAlign="center"
  sx={{
    position: "relative",
    width: "100%",
    height: { xs: "100vh", sm: "62vh", md: "82vh", lg: "110vh", xl: "120vh" },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  }}
>
  {/* Drone Image as an element inside */}
  <Box
    component="img"
    src={mflyingdrone1}
    alt="Flying Drone"
    sx={{
      position: "absolute",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      zIndex: 0,
    }}
  />

  {/* Gradient Overlay */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: isMobile
        ? "linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0))"
        : "linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0))",
      zIndex: 1,
    }}
  />

  {/* Foreground Content */}
  <Box sx={{ position: "relative", zIndex: 2, bottom: {xs:"", sm:"100px", md:"", lg:"100px"} }}>
    <Typography variant="h4" fontWeight={600} color="black"  mb={6}>
      Why Partner with <span style={{ color: "#007bff" }}>Drone Planet?</span>
    </Typography>

    <Grid
      container
      spacing={3}
      
      // justifyContent="center"
      flexDirection={isMobile ? "column" : "row"}
    >
      {/* First Column */}
      <Grid item xs={12} sm={4}>
        <Box
          component="img"
          src={arrdown}
          alt="DGCA Support"
          sx={{
            position: "absolute",
            left: isMobile ? 290 : 320,
            top: isMobile ? 250 : 130,
            width: 80,
            height: 80,
            transform: isMobile ? "rotate(30deg)" : "",
            display: { xs: "none", sm: "none", md: "block" },
          }}
        />
        <Typography fontWeight={600} color="#007bff" fontSize={20} mb={2}>
          DGCA Certification Support
        </Typography>
        <Box display="flex" justifyContent="center">
          <Typography
            color="black"
            width={300}
            fontWeight={700}
            textAlign="center"
            sx={{ textShadow: "1px 1px 3px rgba(0,0,0,0.3)" }}
          >
            We guide you through the approval process to ensure compliance with
            regulatory standards.
          </Typography>
        </Box>
      </Grid>

      {/* Second Column */}
      <Grid item xs={12} sm={4} mt={isMobile ? 10 : 20}>
        <Box
          component="img"
          src={arrup}
          alt="Training Modules"
          sx={{
            position: "absolute",
            right: isMobile ? 300 : 340,
            top: isMobile ? 460 : 130,
            width: 80,
            height: 80,
            transform: isMobile ? "rotate(40deg) scaleY(-1)" : "",
            display: { xs: "none", sm: "none", md: "block" },
          }}
        />
        <Typography fontWeight={600} color="#007bff" fontSize={20} mb={2}>
          Proven Training Modules
        </Typography>
        <Box display="flex" justifyContent="center">
          <Typography
            color="black"
            width={300}
            fontWeight={700}
            textAlign="center"
            sx={{ textShadow: "1px 1px 3px rgba(0,0,0,0.3)" }}
          >
            Access a curriculum curated by industry leaders to produce top-notch drone professionals.
          </Typography>
        </Box>
      </Grid>

      {/* Third Column */}
      <Grid item xs={12} sm={4} mt={isMobile ? 10 : 0}>
        <Typography fontWeight={600} color="#007bff" fontSize={20} mb={2}>
          Established Brand
        </Typography>
        <Box display="flex" justifyContent="center">
          <Typography
            color="black"
            width={300}
            fontWeight={700}
            textAlign="center"
            sx={{ textShadow: "1px 1px 3px rgba(0,0,0,0.3)" }}
          >
            Leverage Drone Planet’s reputation and industry expertise to attract aspiring drone pilots.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </Box>
</Box>





      {/* Franchise Benefits Section */}
      <Box my={{ xs: 4, md: 6 }}>
  <Typography variant={isMobile ? "h4" : "h3"} textAlign="center" fontWeight={600}>
    Franchise <span style={{ color: "#007bff" }}>Benefits</span>
  </Typography>

  <Grid container spacing={3} mt={3}>
    {/* Left Column - Large Box */}
    <Grid item xs={12} md={6}>
      <Box
        p={3}
        borderRadius={1}
        color="white"
        mx="auto"
        sx={{
          position: "relative",
          backgroundImage: `url(${revenueopp})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: { xs: 200, sm: 250, md: 425 },
          width: "100%",
          maxWidth: 600,
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 31, 63, 0.4)",
            borderRadius: "inherit",
          },
        }}
      >
        <Typography 
          fontWeight={600} 
          color="#FFD700" 
          sx={{ 
            position: "relative", 
            zIndex: 1,
            mt: { xs: 0, md: 4 },
            ml: { xs: 0, md: 3 },
            fontSize: { xs: 18, sm: 20 }
          }}
        >
          Revenue Opportunities
        </Typography>
        <Typography 
          sx={{ 
            position: "relative", 
            zIndex: 1,
            ml: { xs: 0, md: 3 },
            fontSize: { xs: 16, sm: 18 }
          }}
        >
          Generate consistent income through training fees and certifications.
        </Typography>
      </Box>
    </Grid>

    {/* Right Column - Two Stacked Boxes */}
    <Grid item xs={12} md={6} container spacing={3} direction="column">
      <Grid item>
        <Box
          p={3}
          borderRadius={1}
          color="white"
          mx="auto"
          sx={{
            position: "relative",
            backgroundImage: `url(${ongoing})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: 200,
            width: "100%",
            maxWidth: { xs: "100%", sm: 600 },
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0))",
              zIndex: 1,
              borderRadius: "inherit",
            },
          }}
        >
          <Box sx={{ position: "relative", zIndex: 2 }}>
            <Typography 
              fontWeight={600} 
              color="#007bff" 
              fontSize={{ xs: 18, sm: 20 }} 
              width={{ xs: "100%", sm: 200 }} 
              mb={1}
            >
              Ongoing Training & Support
            </Typography>
            <Typography 
              color="#000000" 
              width={{ xs: "100%", sm: 300 }}
              fontSize={{ xs: 14, sm: 16 }}
            >
              Get regular updates on training methodologies and regulatory changes.
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid item>
        <Box
          p={3}
          borderRadius={1}
          color="white"
          mx="auto"
          sx={{
            position: "relative",
            backgroundImage: `url(${layer5})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: 200,
            width: "100%",
            maxWidth: { xs: "100%", sm: 600 },
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0))",
              zIndex: 1,
              borderRadius: "inherit",
            },
          }}
        >
          <Box sx={{ position: "relative", zIndex: 2 }}>
            <Typography 
              fontWeight={600} 
              color="#007bff" 
              fontSize={{ xs: 18, sm: 20 }} 
              width={{ xs: "100%", sm: 250 }} 
              mb={1}
            >
              Comprehensive Setup Assistance
            </Typography>
            <Typography 
              color="#000000" 
              width={{ xs: "100%", sm: 340 }}
              fontSize={{ xs: 14, sm: 16 }}
            >
              From facility design to equipment procurement, we provide end-to-end support.
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  </Grid>
</Box>


      {/* Steps to Open Franchise */}
      <Box textAlign="center" my={6}>
        <Typography variant={isMobile?"h4":"h3"} fontWeight={600} mt={10} mb={10}>
          Steps to Open <span style={{ color: "#007bff" }}>Your Franchise</span>
        </Typography>
        <Grid container spacing={3} mt={3}>
        <Grid item xs={12} sm={4}>
          <Typography fontWeight={600} fontSize={20}>Submit Your Interest:</Typography>

          {/* Add Image Below Heading */}
          <Box display="flex" justifyContent="center" my={2}>
            <img src={submitInterestImage} alt="Submit Interest" width={200} height={200} />
          </Box>

          <Box display="flex" justifyContent="center">
            <Typography width={250} textAlign="center">
              Fill out a simple form to initiate the process.
            </Typography>
          </Box>

        </Grid>

          <Grid item xs={12} sm={4}>
            <Typography fontWeight={600} fontSize={20}>Discuss Requirements:</Typography>
            {/* Add Image Below Heading */}
            <Box display="flex" justifyContent="center" my={2}>
              <img src={requirement1} alt="Submit Interest" width={200} height={200} />
            </Box>
            <Box display="flex" justifyContent="center">
              <Typography width={300} textAlign="center">
                Work with our team to finalize location, setup, and DGCA
                requirements.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography fontWeight={600} fontSize={20}>Launch Your RPTO:</Typography>
            {/* Add Image Below Heading */}
            <Box display="flex" justifyContent="center" my={2}>
              <img src={requirement2} alt="Submit Interest" width={200} height={200} />
            </Box>
            <Box display="flex" justifyContent="center">
              <Typography width={250} textAlign="center">
                Open your training center and start offering courses.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Partner with us section */}

      <Box textAlign="center" my={6}>
        <Typography variant={isMobile?"h6":"h5"} fontWeight={600} mt={10} ml={isMobile?1:0}>
          Partner with us and become a part of India's   
        </Typography>
        <Typography variant={isMobile?"h6":"h5"} fontWeight={600} mb={1}>
          growing drone ecosystem.
        </Typography>
        <Typography variant="h6" ml={isMobile?1:0}>
          Together, Let's Train the Pilots of Tomorrow!   
        </Typography>
      </Box>
    </Box>
  );
};

export default FranchisePage;
